import { Typography } from 'antd';
import React from 'react';
import { isMobile } from 'react-device-detect';

const { Title } = Typography;

export default function HomeSectionTitle({ children, extraStyles }) {
  return (
    <Title
      level={4}
      style={{
        // fontSize: isMobile ? '4vmin' : '3vmin',
        // fontWeight: 'bold',
        fontWeight: 500,
        color: '#181818',
        maxWidth: isMobile ? '100%' : '70%',
        ...extraStyles,
      }}
    >
      {children}
    </Title>
  );
}
